<template>
  <button
    type="button"
    :aria-label="ariaLabel"
    :aria-expanded="expanded"
    class="pointer-events-auto flex w-full max-w-xs items-center justify-between gap-2 rounded-lg bg-gray-900/90 dark:bg-gray-100/90 px-3 py-1.5 text-xs font-medium text-white dark:text-gray-900 ring-1 ring-black/15 dark:ring-white/15 hover:bg-gray-900 dark:hover:bg-gray-100 transition-colors"
    @click="$emit('toggle')"
  >
    <span>{{ expanded ? 'Show fewer' : `+${count} more` }}</span>
    <ChevronUpIcon v-if="expanded" class="h-4 w-4" aria-hidden="true" />
    <ChevronDownIcon v-else class="h-4 w-4" aria-hidden="true" />
  </button>
</template>

<script setup>
import { computed } from "vue";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/vue/20/solid";

const props = defineProps({
  count: {
    type: Number,
    required: true,
  },
  expanded: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["toggle"]);

const ariaLabel = computed(() =>
  props.expanded
    ? "Show fewer notifications"
    : `Show ${props.count} more notification${props.count === 1 ? '' : 's'}`
);
</script>
